import { faArrowDown, faArrowUp, faHeartPulse, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLCode from "components/common/HTMLCode";
import If from "components/common/If";
import Translate from "components/common/Translate";
import { DateComparisonResult, DateUtil } from "utilities/date-utilities";
import useAppContext from "utilities/hooks/useAppContext";

type BookingStatusViewPropsType = {
    isCancelled: boolean;
    hasConflict: boolean;
    prefix?: string | React.ReactNode;
    suffix?: string | React.ReactNode;
    icon?: IconDefinition | false;
    outDate: Date;
    inDate: Date;
    addText?: boolean;
}
const BookingStatusView = (props: BookingStatusViewPropsType) => {
    const context = useAppContext();
    const { isCancelled, hasConflict, icon } = props;

    let color = 'text-success';
    let title = context.t('accommodation.booking.status.ok');
    let theIcon = icon || faHeartPulse;
    const inDateComparison = DateUtil.isoDateComperable(props.inDate, new Date());
    const outDateComparison = DateUtil.isoDateComperable(props.outDate, new Date());

    if (isCancelled) {
        color = 'text-danger';
        title = context.t('accommodation.booking.status.cancelled');
    } else if (outDateComparison == DateComparisonResult.LOWER) {
        color = 'text-neutral-500';
        title = context.t('accommodation.booking.status.gone');
    } else if (outDateComparison == DateComparisonResult.EQUAL) {
        color = 'text-neutral-500';
        theIcon = faArrowUp;
        title = context.t('accommodation.booking.status.checkout');
    } else if (hasConflict) {
        color = 'text-warning';
        title = context.t('accommodation.booking.status.conflict');
    } else if (inDateComparison == DateComparisonResult.EQUAL) {
        color = 'text-info';
        theIcon = faArrowDown;
        title = context.t('accommodation.booking.status.checkin');
    } else if (inDateComparison == DateComparisonResult.LOWER) {
        color = 'text-info';
        title = context.t('accommodation.booking.status.staing');
    }

    return <>
        <If condition={props.prefix}>
            <span className={color}>
                {typeof props.prefix === 'string' ? <Translate i18nKey={props.prefix} /> : props.prefix!}
            </span>
            <HTMLCode />
        </If>
        <If condition={props.icon !== false}>
            <FontAwesomeIcon icon={theIcon} className={color} title={title} />
        </If>
        <If condition={props.suffix}>
            <HTMLCode />
            <span className={color}>
                {typeof props.suffix === 'string' ? <Translate i18nKey={props.suffix} /> : props.suffix!}
            </span>
        </If>
        <If condition={props.addText}>
            <HTMLCode />
            <span className={color}>
                {title}
            </span>
        </If>
    </>
};

export default BookingStatusView;
